import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=19046ec2&"
import script from "./LanguagePicker.vue?vue&type=script&lang=js&"
export * from "./LanguagePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports